import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { environment } from '../../../environments/environment';
import { UserService } from 'app/_services/user.service';

@Injectable({ providedIn: 'root' })
export class BuyerMeusVendedoresService extends BaseService {
    private _apiBuyerUrl: string = `${environment.apiBuyer}`;
    private _domain: string = '/my-sellers';

    constructor(private userService: UserService, private config: SettingsService) {
        super();
    }

    public changeSeller(supplierHoldingId: number, newSellerCompanyId: number): Observable<any> {
        const repairerCompanyId = this.userService.userCompanyId();
        const body = { newSellerCompanyId };

        return this.config.executePut({ baseUrl: this._apiBuyerUrl, url: `${this._domain}/${repairerCompanyId}/suppliers/${supplierHoldingId}/change`, body })
    }

    public blockSupplier(supplierHoldingId: number): Observable<any> {
        const repairerHoldingId = this.userService.holdingId();

        return this.config.executePut({ baseUrl: this._apiBuyerUrl, url: `${this._domain}/${repairerHoldingId}/suppliers/${supplierHoldingId}/block` });
    }

    public getAll(): Observable<any> {
        const repairerCompanyId = this.userService.userCompanyId();

        return this.config.executeGet({ baseUrl: this._apiBuyerUrl, url: `${this._domain}/${repairerCompanyId}` })
    }

    public favoriteSupplier(supplierHoldingId: number, favoriteNote?: string) {
        const repairerCompanyId = this.userService.userCompanyId();
        const body = { favoriteNote };

        return this.config.executePut({ baseUrl: this._apiBuyerUrl, url: `${this._domain}/${repairerCompanyId}/suppliers/${supplierHoldingId}/favorite`, body });
    }

    public unblockSupplier(supplierHoldingId): Observable<any> {
        const repairerHoldingId = this.userService.holdingId();

        return this.config.executePut({ baseUrl: this._apiBuyerUrl, url: `${this._domain}/${repairerHoldingId}/suppliers/${supplierHoldingId}/unblock` });
    }

    public unfavoriteSupplier(supplierHoldingId: number) {
        const repairerCompanyId = this.userService.userCompanyId();

        return this.config.executePut({ baseUrl: this._apiBuyerUrl, url: `${this._domain}/${repairerCompanyId}/suppliers/${supplierHoldingId}/unfavorite` });
    }
}
